<template>
  <div>
    <PullRefresh v-model="isReFresh" @refresh="onRefresh">
      <List
        style="height: 100%;padding: 5px 12px"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        loading-text="拼命加载中..."
        @load="onLoad"
        :offset="50"
        :immediate-check="true"
      >
        <TaskDetailItem
          v-for="item in taskPoints"
          :key="item.id"
          :taskDetail="item"
          @onDeal="onDeal"
        />
      </List>
    </PullRefresh>
    <Icon
      name="scan"
      size="39px"
      color="#fff"
      @click="onScan"
      class="float-btn-scan"
    />
    <TaskDealPopup
      :show="show"
      type="taskDealPopup"
      @panel="switchPanel"
      :taskDetail="selected"
      @onRefresh="onRefresh"
    />
  </div>
</template>

<script>
import { Icon, List, PullRefresh } from "vant";
import TaskDetailItem from "./components/TaskDetailItem";
import TaskDealPopup from "./components/TaskDealPopup";
import wx from "weixin-js-sdk";

export default {
  components: { TaskDetailItem, TaskDealPopup, PullRefresh, List, Icon },
  props: {},
  data() {
    return {
      taskId: this.$route.params.id,
      taskState: this.$route.params.state,
      positionId: this.$route.params.positionId,
      isReFresh: false,
      loading: false,
      finished: false,
      taskPoints: [],
      show: false,
      selected: {},
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    onScan() {
      const This = this;
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: function(res) {
          let resultStr = res.resultStr;
          let index = resultStr.indexOf(`CODE_128,`);
          if (index > -1) {
            let len = resultStr.length;
            resultStr = resultStr.slice(index + 9, len - 1);
          }
          let json;
          try {
            const arr = resultStr.split("/pamera/");
            const str = arr[arr.length - 1];
            json = JSON.parse(str);
            if (json.type == "SAFETY_POSITION") {
              This.searchPoint(json.safetyPositionId);
            } else {
              This.$toast.fail("该二维码不是打卡点");
            }
          } catch (e) {
            // 不是json
            This.$toast.fail("该二维码不是打卡点");
          }
        },
      });
    },
    searchPoint(positionId) {
      const selected = this.taskPoints.find(
        (item) => item.positionId == positionId
      );
      if (!selected) {
        this.$toast.fail("该打卡点不在此任务内");
      } else {
        this.onDeal(selected);
      }
    },
    onDeal(selected) {
      this.selected = { ...selected };
      if (this.taskState == "FINISH" && selected.state == "UN_HANDLE") {
        // 任务结束且未处理
        this.$toast.fail("该任务已过期");
        return;
      }

      const routerType = "UN_HANDLE" == selected.state ? "submit" : "view"; // 已提交或任务已结束就只能查看
      if (this.positionId)
        this.$router.replace(`/safety/${routerType}/${this.selected.id}`);
      else this.$router.push(`/safety/${routerType}/${this.selected.id}`);
    },
    switchPanel(type, data) {
      switch (type) {
        case "taskDealPopup":
          this.show = !this.show;
          break;
        default:
          break;
      }
    },
    onRefresh() {
      this.isReFresh = true;
      this.taskPoints = [];
      this.onLoad(true);
    },
    onLoad(isPullRefresh) {
      this.$http.tokiot.safety.task.position
        .list({
          taskId: this.taskId,
          size: 20,
          page: this.taskPoints.length / 20 + 1,
        })
        .then((res) => {
          if (res) {
            this.taskPoints.push(...res.rows);
            this.loading = false;
            if (isPullRefresh) this.isReFresh = false;
            if (this.taskPoints.length >= res.total) {
              this.finished = true;
            }
            if (this.positionId) {
              this.positionId && this.searchPoint(this.positionId);
            }
          }
        });
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.float-btn-scan {
  background: #1988fa;
  border-radius: 50%;
  padding: 8px;
  position: fixed;
  bottom: 28px;
  right: 20px;
  z-index: 999;
  /*box-shadow: 3px 3px 5px rgb(226, 225, 225);*/
}
</style>